import {TokenService} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';

export const CreateFileCa = ({header, dataKey, refreshLazyData}) => {

  const {render, create} = useDialogCrup({
    header,
    dataKey,
    width: '40rem',
    fields: [
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h2>FILE CA</h2>},
      {field: 'files', header: 'Tải lên tệp chứng thư số', required: true, type: 'file', InputFileProps: {accept: '.p12, .fpx'}, className: 'md:col-12 mb-1'},
      {
        type: 'custom', className: 'md:col-12 mb-4', body: <i>Định dạng hợp lệ là tệp đuôi .p12 hoặc .fpx</i>
      },
      {field: 'passwordCer', header: 'Mật khẩu chứng thư số', type: 'Password', required: true, className: 'md:col-12'}
    ],
    createItem: (item) => {
      const {passwordCer, files} = item;
      const formData = new FormData();
      formData.append('files', files);
      return TokenService.uploadCertificate(passwordCer, formData);
    },
    refreshLazyData
  });

  return {render, open: create};

}